import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';

import { EZIndexes } from '@/enums/EZIndexes';

const TooltipProvider = TooltipPrimitive.Provider;

const TooltipPortal = TooltipPrimitive.Portal;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<React.ElementRef<typeof TooltipPrimitive.Content>, React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>>(
  ({ className, sideOffset = 4, ...props }, ref) => (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={` ${className}
      ${EZIndexes.TOOLTIP} 
      px-3 py-1.5 
      w-full
      cursor-default 
      border border-neutral-200 dark:border-neutral-800
      rounded-md bg-white dark:bg-neutral-950
      shadow-md
      text-sm text-neutral-950 dark:text-neutral-50
      animate-in fade-in-0 zoom-in-95 
      
      data-[state=closed]:animate-out 
      data-[state=closed]:fade-out-0 
      data-[state=closed]:zoom-out-95 

      data-[side=bottom]:slide-in-from-top-2 
      data-[side=left]:slide-in-from-right-2 
      data-[side=right]:slide-in-from-left-2 
      data-[side=top]:slide-in-from-bottom-2 
       
       
      
    `}
      {...props}
    />
  ),
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger };
